export enum TrainingLevel {
	NewPlayer,
	SecondGame,
	MultiplayerIntro,
	Trained
}

export interface PlayerAccount {
	trainingLevel: TrainingLevel;
	achievements: Array<string>;
}